// tslint:disable
export enum QpsignatureSignatureStatus {
    /**
     * @description $2
     */
    Unknown = 0,
    /**
     * @description $2
     */
    Created = 1,
    /**
     * @description $2
     */
    Deleted = 2,
    /**
     * @description $2
     */
    Sent = 3,
    /**
     * @description $2
     */
    Delivered = 4,
    /**
     * @description $2
     */
    Signed = 5,
    /**
     * @description $2
     */
    Completed = 6,
    /**
     * @description $2
     */
    Declined = 7,
    /**
     * @description $2
     */
    Timedout = 8,
    /**
     * @description $2
     */
    Voided = 9,
}
(QpsignatureSignatureStatus as any)['UNKNOWN'] = 0;
(QpsignatureSignatureStatus as any)['CREATED'] = 1;
(QpsignatureSignatureStatus as any)['DELETED'] = 2;
(QpsignatureSignatureStatus as any)['SENT'] = 3;
(QpsignatureSignatureStatus as any)['DELIVERED'] = 4;
(QpsignatureSignatureStatus as any)['SIGNED'] = 5;
(QpsignatureSignatureStatus as any)['COMPLETED'] = 6;
(QpsignatureSignatureStatus as any)['DECLINED'] = 7;
(QpsignatureSignatureStatus as any)['TIMEDOUT'] = 8;
(QpsignatureSignatureStatus as any)['VOIDED'] = 9;
